import { http } from "../client";
export var createMusicArchive = function (request) {
    return http.api
        .post("music-archives", {
        playlist_id: request.playlistId
    })
        .then(function (response) { return response.data.data; });
};
